import React from "react";
import { ControlError, Toggle, Label } from "@forge/common";

interface ToggleComponentProps {
  setting: any;
  newSettings: any[];
  onInputChange: (
    event: any,
    setting: any,
    productId: string,
    errorMessage: string
  ) => void;
  productId: string;
  settingKeyValidation: any;
}

const ToggleComponent: React.FC<ToggleComponentProps> = ({
  setting,
  newSettings,
  onInputChange,
  productId,
  settingKeyValidation,
}) => {
  const currentBooleanSetting = newSettings?.find(
    (x: { key: any }) => x.key === setting.key
  );
  const checkboxValue =
    currentBooleanSetting?.value ?? setting?.defaultValue ?? "true";
  const checked = checkboxValue === true || checkboxValue === "true";
  const booleanErrorMessage = currentBooleanSetting?.errorMessage ?? "";
  const isRequired = setting?.required === true;

  return (
    <div className="sso-checkbox-wrapper pb-6">
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Toggle
          id={setting?.key}
          name={setting?.key}
          checked={checked}
          value={checked ? "true" : "false"}
          onChange={(event: any) => {
            const nextValue = String(event?.target?.checked ?? false);
            const validationError = settingKeyValidation?.onChange({
              target: { value: nextValue },
            });
            onInputChange(
              { target: { value: nextValue, checked: event?.target?.checked } },
              setting,
              productId,
              validationError ?? ""
            );
          }}
          error={Boolean(booleanErrorMessage)}
        />
        <Label htmlFor={setting?.key} required={isRequired}>
          {setting?.displayName}
        </Label>
      </div>
      {booleanErrorMessage && (
        <ControlError>{booleanErrorMessage}</ControlError>
      )}
    </div>
  );
};

export default ToggleComponent;
